"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Shield, Zap, Target, TrendingUp } from "lucide-react";
export default function ServiceDetailsSection() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const benefits = [{
    icon: Shield,
    title: "Sécurité Robuste",
    description: "Mise en œuvre des principes de sécurité dès la conception."
  }, {
    icon: Zap,
    title: "Performance Éclair",
    description: "Optimisation de l'infrastructure cloud pour une efficacité maximale."
  }, {
    icon: Target,
    title: "Alignement Stratégique",
    description: "Alignement de la stratégie cloud avec vos objectifs métier."
  }, {
    icon: TrendingUp,
    title: "Croissance Évolutive",
    description: "Construction de plateformes qui évoluent de manière transparente avec votre succès."
  }];
  return <section className="bg-background py-20 px-6">
      <div className="mx-auto max-w-7xl">
        <div ref={containerRef} className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          {}
          <div className="transition-all duration-500 ease-out-back" style={{
          opacity: containerVisible ? 1 : 0,
          transform: containerVisible ? "translateY(0)" : "translateY(1.5rem)"
        }}>
            <Card className="glass-effect border border-muted/30 bg-surface/80 backdrop-blur-md p-8">
              <CardContent className="space-y-6 p-0">
                <h2 className="font-display text-4xl font-bold text-foreground lg:text-5xl">
                  Stratégie Cloud & Transformation
                </h2>
                <p className="text-lg leading-relaxed text-muted-foreground">
                  Nous guidons les organisations à travers des parcours cloud complexes—des architectures hybrides et multi-cloud aux solutions de cloud souverain. Notre approche garantit une gouvernance robuste, des modèles opérationnels optimisés et une intégration transparente avec votre infrastructure existante.
                </p>
                <p className="text-base leading-relaxed text-muted-foreground">
                  Associez-vous à NorthStar Advisory pour maîtriser la complexité de la transformation cloud et créer de la valeur durable grâce à la clarté stratégique et l'excellence technologique.
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="flex flex-col justify-center space-y-6">
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div key={i} data-index={i} className="group flex items-start gap-4 transition-all duration-300 ease-out-back" style={{
              opacity: containerVisible ? 1 : 0,
              transform: containerVisible ? "translateY(0)" : "translateY(1rem)",
              transitionDelay: containerVisible ? `${i * 100 + 200}ms` : "0ms"
            }}>
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary/10 border border-primary/20 transition-all duration-300 group-hover:bg-primary/20 group-hover:shadow-[0_0_20px_rgba(59,130,246,0.3)]">
                    <Icon className="h-6 w-6 text-foreground transition-transform duration-300 group-hover:scale-110" />
                  </div>
                  <div className="flex-1 space-y-1">
                    <h3 className="font-display text-xl font-semibold text-foreground">
                      {benefit.title}
                    </h3>
                    <p className="text-sm leading-relaxed text-muted-foreground">
                      {benefit.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}